<template>
    <div class="position-relative d-flex flex-column h-100">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-left donation-back-icon"
            viewBox="0 0 16 16"
            @click="backStep"
        >
            <path
                fill-rule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
            />
        </svg>
        <div class="flex-grow-1">
            <h2 class="donation-title text-center mb-3">Mailing Address</h2>
            <TextField
                v-model="address"
                name="address"
                input-type="2"
                classWrapper="mb-3"
                placeholder="Address"
            />
            <TextField
                v-model="address2"
                name="address2"
                input-type="2"
                classWrapper="mb-3"
                placeholder="Address line 2"
            />
            <TextField
                v-model="city"
                name="city"
                input-type="2"
                classWrapper="mb-3"
                placeholder="City"
            />
            <TextField
                v-model="zipCode"
                name="zipCode"
                input-type="2"
                classWrapper="mb-3"
                placeholder="Zip code"
            />
            <SelectField
                v-if="!isChangingCountry"
                v-model="state"
                name="state"
                :options="stateOptions"
                :disabled="isDisabledStateOptions"
                input-type="2"
                classWrapper="mb-3 select-state"
                placeholder="State"
            />
            <SelectField
                v-model="country"
                name="country"
                :options="country_codes"
                input-type="2"
                placeholder="Country"
            />
        </div>
        <button @click="submit"
                :disabled="!isValid"
                class="btn w-100 ok-btn mt-3">
            {{ donationData.questions.length > 0 ? 'Continue' : `Donate ${donateAmount}`}}
        </button>
    </div>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import SelectField from '@/commons/FormElements/SelectField.vue';
export default {
    name: 'MailingAddress',
    components: {
        TextField,
        SelectField,
    },
    props: {
        donateAmount: String,
        donationData: {
            type: Object,
            default: () => ({}),
        },
        donationFormData: {
            type: Object,
            default: () => ({}),
        },
        country_codes: {
            type: Array,
            default: () => [],
        },
        states: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        stateOptions() {
            return this.country === 'US' ? this.states : this.stateOutsideUS;
        },
        isDisabledStateOptions() {
            return this.country !== 'US';
        },
        isValid() {
            return (
                this.address &&
                this.city &&
                this.zipCode &&
                (this.country === 'US' ? this.state : true)
            );
        },
    },
    watch: {
        country(value) {
            console.log('country', value)
            this.isChangingCountry = true;
            if (value !== 'US') {
                this.previous_state = this.state;
                this.state = '';
            } else {
                this.state = this.previous_state;
            }

            setTimeout(() => {
                this.isChangingCountry = false;
            }, 100);
        },
    },
    created() {
        this.address = this.donationFormData.address;
        this.address2 = this.donationFormData.address2;
        this.city = this.donationFormData.city;
        this.zipCode = this.donationFormData.zipCode;
        this.state = this.donationFormData.state;
        this.country = this.donationFormData.country;
    },
    data() {
        return {
            isChangingCountry: false,
            address: '',
            address2: '',
            city: '',
            zipCode: '',
            state: '',
            listState: [],
            country: 'US',
            listCountry: [],
            previous_state: '',
            stateOutsideUS: [
                {
                    value: '',
                    label: 'Outside of the US',
                },
            ],
        };
    },
    methods: {
        backStep() {
            this.$emit('changeStep', 3);
            this.$emit('updateData', {
                address: this.address,
                address2: this.address2,
                city: this.city,
                zipCode: this.zipCode,
                state: this.state,
                country: this.country,
            });
        },
        submit() {
            this.$emit('updateData', {
                address: this.address,
                address2: this.address2,
                city: this.city,
                zipCode: this.zipCode,
                state: this.state,
                country: this.country,
            });
            this.$emit('changeStep', this.donationData.questions.length > 0 ? 5 : 6);
        },
    },
};
</script>
<style lang="scss">
.select-state{
    .disabled {
        opacity: 0.7;
    }
}
</style>
